import { render, staticRenderFns } from "./CurrentTeamTable.vue?vue&type=template&id=410d02a6&"
import script from "./CurrentTeamTable.vue?vue&type=script&lang=js&"
export * from "./CurrentTeamTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports